module.exports = __webpack_public_path__ + "index/img/api.d9f3e4d0.png";